module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      staticClass: "slide-image",
      attrs: {
        "src": slide
      }
    }), _vm._v(" "), _c('p', [_vm._v("Slide: " + _vm._s(index + 1))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03488b00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slider.vue
// module id = 633
// module chunks = 1